import * as React from 'react'
import { IBacnetDevice } from './types'
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { MdTimer } from 'react-icons/md'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';
import { IsValidIpAddress } from '../../../utils/validations';
import { Button } from 'baseui/button';
import { Block } from 'baseui/block';
import { UpdateObjectInstanceCommand, useUpdateObjectMutation } from '../../../services/objects';
import { useReportMutationState } from '../../../hooks/useReportMutationState';

export const ConfigurationPanel = (props: IBacnetDevice) => {

    const [updateClass, setValueResult] = useUpdateObjectMutation();

    const [state, setState] = React.useState({
        routedSource: props.routedSource,
        timeout: props.timeout,
        ipAddress: props.ipAddress,
        hasChanges: false
    })
    const [isValidIp, setIsValidIp] = React.useState<boolean>(true);
    const [isValidTimeout, setIsValidTimeout] = React.useState<boolean>(true);

    const onApplyChangesSuccess = () => {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            hasChanges: false,
        }));
    }
    useReportMutationState(setValueResult,onApplyChangesSuccess);
    const onIpAddressChanged = (args: any) => {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            ipAddress: args.target.value,
            hasChanges: true,
        }));
        setIsValidIp(IsValidIpAddress(args.target.value));
    }
    const onTimeoutChanged = (args: any) => {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            timeout: args.target.value,
            hasChanges: true,
        }));
        setIsValidTimeout(args.target.value > 1000 && args.target.value < 600000)
    }
    const onRoutedSourceChanged = (args: any) => {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            routedSource: args.target.value,
            hasChanges: true,
        }));
    }

    const onApplyChanges = (args: any) => {
        const cmd: UpdateObjectInstanceCommand = {
            objectId: props.id,
            resourceGroupid: props.resourceGroupId,
            properties: [
                { key: "ipAddress", value: state.ipAddress },
                { key: "timeout", value: state.timeout },
                { key: "routedSource", value: state.routedSource }
            ]
        };
        updateClass(cmd);
    }



    const canApplyChanges = isValidIp && isValidTimeout && state.hasChanges;

    return (
        <>
            <FormControl
                error={!isValidIp && "Value must be a valid IPv4 Address"}
                label={<FormattedMessage id="Devices.IPAddress" defaultMessage="IP Address" />}
                caption={<FormattedMessage id="Devices.TextIPAddress" defaultMessage="Enter the IP Address of the BACnet Device" />}
            >
                <Input value={state.ipAddress} onChange={onIpAddressChanged} required placeholder="Enter IP Address ..." />
            </FormControl>

            <FormControl
                error={!isValidTimeout && "Value must be between 1000 and 60000msec"}
                label={<FormattedMessage id="Devices.Timeout" defaultMessage="Timeout" />}
                caption={<FormattedMessage id="Devices.TextTimeout" defaultMessage="Enter a Communication Timeout in msec" />}
            >
                <Input value={state.timeout} type='number' onChange={onTimeoutChanged} required placeholder="Timeout ..." endEnhancer='ms' />
            </FormControl>

            <FormControl
                label={<FormattedMessage id="Devices.RoutedSource" defaultMessage="Routed source" />}
                caption={<FormattedMessage id="Devices.TextRoutedSource" defaultMessage="Specifiy a routed source only if your device is behind a BACnet router" />}
            >
                <Input value={state.routedSource} onChange={onRoutedSourceChanged} required placeholder="Routes Souce ..." />
            </FormControl>

            <Button isLoading={setValueResult.isLoading} size='compact' disabled={!canApplyChanges} onClick={onApplyChanges} overrides={{
                BaseButton: {
                    style: ({ $theme }) => ({
                        width: '100%'
                    })
                }
            }}><FormattedMessage id="applyChanges" defaultMessage="Apply changes" /></Button>

        </>

    )

}
